import Vue from 'vue';

var vm = new Vue();

module.exports = {
    on:function (eventName,callback) {
        vm.$on(eventName,callback);
    },
    emit:function (eventName,data) {
        vm.$emit(eventName,data);
    },
    off:function () {
        vm.$off.apply(vm,arguments);
    }
}


// WEBPACK FOOTER //
// src/lib/event.js